import ToolsHelper from '@core/services/tools.helper';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-pos-checkout-keyboard',
  components: {},
})
export default class PosCheckoutKeyboard extends Vue {
  @Prop({ type: Number, default: 0 }) readonly value: number;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;

  public stringValue = '0';
  public decimalMode = 2;

  mounted() {
    window.addEventListener('keyup', this.onKeyup);
  }
  destroyed() {
    window.removeEventListener('keyup', this.onKeyup);
  }

  get keyUpAvailable() {
    return (
      this.$store.getters['pos/showDrawer'] &&
      this.$store.getters['pos/posExpanded'] &&
      !this.$store.getters['pos/modalsOpened']
    );
  }

  onKeyup(e) {
    if (this.keyUpAvailable) {
      const numberValidCharacters = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      if (numberValidCharacters.includes(e.key) && !this.disableAddButton()) {
        this.add(e.key);
      }
      const commaValidCharacters = [',', '.'];
      if (commaValidCharacters.includes(e.key) && !this.disableCommaButton()) {
        this.add(',');
      }
      const clearValidCharacters = ['c'];
      if (clearValidCharacters.includes(e.key)) {
        this.clear();
      }
      const removeValidCharacters = ['Backspace'];
      if (removeValidCharacters.includes(e.key)) {
        this.remove();
      }
    }
  }

  changeDecimalMode(decimalMode): void {
    this.decimalMode = decimalMode;
  }

  get model(): number {
    return this.value;
  }
  set model(val: number) {
    this.$emit('input', val);
  }

  add(digit: string) {
    if (this.stringValue != '0') {
      this.stringValue += digit;
    } else {
      this.stringValue = digit;
    }
    this.$emit('input', this.parseFloat(this.stringValue));
  }
  disableAddButton() {
    if (!this.disabled) {
      if (this.stringValue.indexOf(',') !== -1) {
        const parts = this.stringValue.split(',');
        return parts[1].length >= this.decimalMode;
      }
      return false;
    }
    return true;
  }
  disableCommaButton() {
    return this.disabled || this.stringValue.indexOf(',') !== -1 || this.stringValue == '0';
  }
  remove() {
    if (this.stringValue.length == 1) {
      this.stringValue = '0';
    } else {
      this.stringValue = this.stringValue.slice(0, -1);
    }
    this.$emit('input', this.parseFloat(this.stringValue));
  }
  clear() {
    this.stringValue = '0';
    this.$emit('input', this.parseFloat(this.stringValue));
  }

  parseFloat(val: string): number {
    return parseFloat(val.replace(',', '.'));
  }

  get currentTicket() {
    return this.$store.getters['pos/currentTicket'];
  }
  get showDrawer() {
    return this.$store.getters['pos/showDrawer'];
  }

  addNegativeNumber(): void {
    switch (Math.sign(parseFloat(this.stringValue))) {
      case -0:
        break;
      case 0:
      case 1:
        this.stringValue = `-${this.stringValue}`;
        this.$emit('input', this.parseFloat(this.stringValue));
        break;
      case -1:
        this.stringValue = this.stringValue.replace('-', '');
        this.$emit('input', this.parseFloat(this.stringValue));
        break;
    }
  }

  get currentTicketBalance() {
    return this.$store.getters['pos/currentTicketBalance'];
  }

  get currentTicketId(): number {
    return this.$store.getters['pos/currentTicketId'];
  }

  @Watch('currentTicketBalance')
  onChangeCurrentTicketBalance(val) {
    this.stringValue = '0';
  }
  @Watch('currentTicketId')
  onChangeCurrentTicket(val) {
    this.stringValue = '0';
  }
  @Watch('stringValue')
  onUpdateStringValue(val) {
    if (val === 'NaN') {
      this.clear();
    }
  }
}
